// export enum PermissaoGeral {
//   Administrador = '0',
//   Médico = '1',
//   Enfermeiro = '2',
//   Paciente = '3',
//   Secretário = '4',
//   Regulação = '5',
//   Motorista = '6',
//   SecretariaTransporte = '7',
//   ChefeTransporte = '8'
// }
export const PermissaoGeral = {
  Administrador: '0',
  Médico: '1',
  Enfermeiro: '2',
  Paciente: '3',
  Secretário: '4',
  Regulação: '5',
  Motorista: '6',
  SecretariaTransporte: '7',
  ChefeTransporte: '8',
  ConsorcioTransporte: '9'
}

export const AuditoriaStatus = {
  Aguardando: 'Aguardando resposta',
  Comentado: 'Comentado',
  Finalizado: 'Finalizado',
}

export const FilaProcedimentoEnum = {
  Aguardando: 'Aguardando',
  ProcedimentoAgendado: 'Procedimento Agendado',
  Recusado: 'Procedimento Recusado',
}

export const FilaProcedimentoRecusaEnum = {
  FimFila: 'Enviar paciente para o final da fila',
  Remover: 'Remover paciente da fila',
}